<template>
  <Modal :id="id" title="Cancel Event" :hideClose="true">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <Field
              type="select"
              name="cancellation_type"
              label="Reason for Cancellation"
              :options="cancellationTypes"
              v-model="selectedType"
              :hide-select-empty-option="true"
            />
          </div>
        </div>
        <div v-show="showOtherInput" class="col-12">
          <div class="form-group">
            <Field type="text" name="cancel_reason" v-model="cancelReason" />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a
          class="btn btn-danger"
          :class="{disabled: loading}"
          :disabled="loading"
          href="#"
          @click.prevent="submit()"
      >
          {{ loading ? 'Cancelling...' : 'Cancel Event' }}
      </a>
      <a
          class="btn btn-info"
          :class="{disabled: loading}"
          :disabled="loading"
          href="#"
          @click.prevent="close()"
      >Close Window</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";

export default {
    mixins: [ModalMixin],

    data() {
        return {
            id: "cancel-event-modal",
            event: null,
            cancellationTypes: [],
            selectedType: null,
            cancelReason: "",
            loading: false,
        };
    },

    computed: {
        routeParam() {
            return {event: this.event.id};
        },
        selectedReason() {
            return (
                this.cancellationTypes.filter((type) => type.value == this.selectedType)
                    .label || ""
            );
        },
        showOtherInput() {
            return this.selectedType == this.$root.constants.CANCEL_REASON_OTHER;
        },
    },

    watch: {
        selectedType(val) {
            if (val == this.$root.constants.CANCEL_REASON_OTHER) {
                this.cancelReason = "";
            } else {
                this.cancelReason = this.selectedType;
            }
        },
    },

    methods: {
        submit() {
            this.loading = true;
            const route = this.$root.isAdmin
                ? 'admin.events.cancel'
                : 'training.events.cancel';

            this.axios
                .post(this.route(route, this.routeParam), {
                    cancel_reason: this.cancelReason,
                })
                .then(() => {
                    this.resolve();
                    this.loading = false;
                }).catch((e) => {
                    this.loading = false;
                })
        },
    },

    mounted() {
        this.event = _.cloneDeep(this.options.event);
        this.cancellationTypes = this.options.cancellationTypes;
    },
};
</script>
